module.exports = __webpack_public_path__ + "static/media/industries-refactories-s.df11fe45.webp";